<template>
  <div class="form__image">
    <div class="form__preview">
      <img :src="modelImage ? modelImage : baseUrl('/img/user.jpg')" :alt="label" ref="preview">
    </div>

    <div class="form__actions">
      <button type="button" class="form__upload" @click="hiddenClick()">
        Anexar Imagem
      </button>

      <div class="form__isizes">
        {{ imgWidth }}x{{ imgHeight }}px - JPG/PNG - MAX: 200KB
      </div>

      <div class="form__iwarning" v-show="imageIsInvalid">
        Tamanho ou dimensões da imagem inválidas!
      </div>

      <input type="file" class="hidden" ref="upload" @change="hiddenChange" accept=".jpg,.jpeg,.png">
    </div>
  </div>
</template>

<script>
import { baseUrl } from '@helpers/functions';
import storage from 'storage';
import axios from 'axios';

export default {
  name: 'FormImage',
  props: {
    label: {
      type: String,
      required: true
    },
    modelImage: {
      type: String,
      required: false
    },
    imgWidth: {
      type: Number,
      default: 200
    },
    imgHeight: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      imageIsInvalid: false
    }
  },
  emits: ['update:modelImage'],
  methods: {
    baseUrl,
    hiddenClick() {
      this.$refs.upload.click();
    },
    hiddenChange(event) {
      this.imageIsInvalid = false;
      if(event.target.files.length > 0){
        const file = event.target.files[0];

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onloadend = () => {
          const img = new Image();
          img.src = reader.result;

          img.onload = () => {
          if (img.width === this.imgWidth && img.height === this.imgHeight) {
            this.$emit('update:modelImage', reader.result);

            const local = 'mail4fly--user';
            const { user_token } = storage.get(local);

            const endpoint = `${baseUrl('', 'api')}/upload/${user_token}`;
            const headers = { headers: { 'Content-Type': 'multipart/form-data' }};

            const formData = new FormData();
            formData.append('file', file);

            axios.post(endpoint, formData, headers).then((res) => {
              const { data: { data: { fullUrl } } } = res;
              this.$emit('update:modelImage', fullUrl);
            }).catch(() => {
              this.$emit('update:modelImage', '');
              this.imageIsInvalid = true;
            });

          } else {
            this.$emit('update:modelImage', '');
            this.imageIsInvalid = true;
          }
        };
        };
      }
    }
  }
}
</script>
